import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const dashboardState = {
  dashboard: null,
  inboxDetail: null,
  inboxComment: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: dashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    dashboardFetched: (state, action) => {
      state.listLoading = false;
      state.dashboard = action.payload.data ?? {};
    },
    inboxDetailFetched: (state, action) => {
      state.listLoading = false;
      state.inboxDetail = action.payload.data ?? {};
    },
    inboxDetailCleared: (state, action) => {
      state.inboxDetail = null;
    },
    inboxCommentFetched: (state, action) => {
      state.listLoading = false;
      state.inboxDetail = {
        ...state.inboxDetail,
        ...(action.payload.data ?? {}),
        memberInboxDetails: [
          ...state.inboxDetail.memberInboxDetails,
          ...(action.payload.data?.memberInboxDetails ?? []),
        ],
      };
    },
    commentCreated: (state, action) => {
      state.actionsLoading = false;
    },
  },
});
